import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-seafarers',
  templateUrl: './seafarers.component.html',
  styleUrls: ['./seafarers.component.css']
})
export class SeafarersComponent implements OnInit {
  url: string;

  constructor(private router: Router) { }

  ngOnInit() {
    this.url = this.router.url;
  }

}
